import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Grid,
  Paper,
  Typography,
  Divider,
  TextField,
  MenuItem,
  Stack,
} from "@mui/material";
import { useLogger } from "../../../../contexts/LoggerContext";
import { PlayDetails } from "./PlayDetails";
import { GameClockInput } from "../Components/GameClockInput";

interface SavePlayProps {
  open: boolean;
  onClose: () => void;
}

export const SavePlayDialog = (props: SavePlayProps) => {
  const { open, onClose } = props;
  const { onSaveCurrentPlay, setCurrentPlayLog, setCurrentPlayCall } =
    useLogger();

  const handleSaveCurrentPlay = () => {
    onSaveCurrentPlay();
    setCurrentPlayLog(null);
    setCurrentPlayCall(null);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: 1100,
          justifyContent: "center",
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle>Save Play Log</DialogTitle>
      <DialogContent>
        
          <PlayDetails />


        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
          <Button onClick={onClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleSaveCurrentPlay}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
